/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MaintenanceListUpdate
 */
export interface MaintenanceListUpdate {
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceListUpdate
     */
    vehicleStatus?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceListUpdate
     */
    vehicleSerialNumber?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceListUpdate
     */
    vehicleManufacturer?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceListUpdate
     */
    vehicleModel?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceListUpdate
     */
    vehicleEngineType?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceListUpdate
     */
    vehicleManufactureYear?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceListUpdate
     */
    vehiclePurchaseDateOrContractTermStart?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceListUpdate
     */
    vehicleContractTermEnd?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceListUpdate
     */
    vehicleContractDaysRemaining?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceListUpdate
     */
    vehicleInitialOperatingHours?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceListUpdate
     */
    vehicleCurrentOperatingHours?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceListUpdate
     */
    vehicleLastMaintenanceOperatingHours?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceListUpdate
     */
    vehicleLastMaintenanceDate?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceListUpdate
     */
    vehicleNextMaintenanceHours?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceListUpdate
     */
    vehicleMaintenanceInterval?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceListUpdate
     */
    vehicleMaintenanceNotificationAt?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceListUpdate
     */
    vehicleMaintenanceLockdown?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceListUpdate
     */
    vehicleHoursUntilNextMaintenance?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceListUpdate
     */
    vehicleTypeLabel?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceListUpdate
     */
    departmentLabel?: boolean | null;
}

/**
 * Check if a given object implements the MaintenanceListUpdate interface.
 */
export function instanceOfMaintenanceListUpdate(value: object): value is MaintenanceListUpdate {
    return true;
}

export function MaintenanceListUpdateFromJSON(json: any): MaintenanceListUpdate {
    return MaintenanceListUpdateFromJSONTyped(json, false);
}

export function MaintenanceListUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MaintenanceListUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'vehicleStatus': json['vehicleStatus'] == null ? undefined : json['vehicleStatus'],
        'vehicleSerialNumber': json['vehicleSerialNumber'] == null ? undefined : json['vehicleSerialNumber'],
        'vehicleManufacturer': json['vehicleManufacturer'] == null ? undefined : json['vehicleManufacturer'],
        'vehicleModel': json['vehicleModel'] == null ? undefined : json['vehicleModel'],
        'vehicleEngineType': json['vehicleEngineType'] == null ? undefined : json['vehicleEngineType'],
        'vehicleManufactureYear': json['vehicleManufactureYear'] == null ? undefined : json['vehicleManufactureYear'],
        'vehiclePurchaseDateOrContractTermStart': json['vehiclePurchaseDateOrContractTermStart'] == null ? undefined : json['vehiclePurchaseDateOrContractTermStart'],
        'vehicleContractTermEnd': json['vehicleContractTermEnd'] == null ? undefined : json['vehicleContractTermEnd'],
        'vehicleContractDaysRemaining': json['vehicleContractDaysRemaining'] == null ? undefined : json['vehicleContractDaysRemaining'],
        'vehicleInitialOperatingHours': json['vehicleInitialOperatingHours'] == null ? undefined : json['vehicleInitialOperatingHours'],
        'vehicleCurrentOperatingHours': json['vehicleCurrentOperatingHours'] == null ? undefined : json['vehicleCurrentOperatingHours'],
        'vehicleLastMaintenanceOperatingHours': json['vehicleLastMaintenanceOperatingHours'] == null ? undefined : json['vehicleLastMaintenanceOperatingHours'],
        'vehicleLastMaintenanceDate': json['vehicleLastMaintenanceDate'] == null ? undefined : json['vehicleLastMaintenanceDate'],
        'vehicleNextMaintenanceHours': json['vehicleNextMaintenanceHours'] == null ? undefined : json['vehicleNextMaintenanceHours'],
        'vehicleMaintenanceInterval': json['vehicleMaintenanceInterval'] == null ? undefined : json['vehicleMaintenanceInterval'],
        'vehicleMaintenanceNotificationAt': json['vehicleMaintenanceNotificationAt'] == null ? undefined : json['vehicleMaintenanceNotificationAt'],
        'vehicleMaintenanceLockdown': json['vehicleMaintenanceLockdown'] == null ? undefined : json['vehicleMaintenanceLockdown'],
        'vehicleHoursUntilNextMaintenance': json['vehicleHoursUntilNextMaintenance'] == null ? undefined : json['vehicleHoursUntilNextMaintenance'],
        'vehicleTypeLabel': json['vehicleTypeLabel'] == null ? undefined : json['vehicleTypeLabel'],
        'departmentLabel': json['departmentLabel'] == null ? undefined : json['departmentLabel'],
    };
}

export function MaintenanceListUpdateToJSON(json: any): MaintenanceListUpdate {
    return MaintenanceListUpdateToJSONTyped(json, false);
}

export function MaintenanceListUpdateToJSONTyped(value?: MaintenanceListUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vehicleStatus': value['vehicleStatus'],
        'vehicleSerialNumber': value['vehicleSerialNumber'],
        'vehicleManufacturer': value['vehicleManufacturer'],
        'vehicleModel': value['vehicleModel'],
        'vehicleEngineType': value['vehicleEngineType'],
        'vehicleManufactureYear': value['vehicleManufactureYear'],
        'vehiclePurchaseDateOrContractTermStart': value['vehiclePurchaseDateOrContractTermStart'],
        'vehicleContractTermEnd': value['vehicleContractTermEnd'],
        'vehicleContractDaysRemaining': value['vehicleContractDaysRemaining'],
        'vehicleInitialOperatingHours': value['vehicleInitialOperatingHours'],
        'vehicleCurrentOperatingHours': value['vehicleCurrentOperatingHours'],
        'vehicleLastMaintenanceOperatingHours': value['vehicleLastMaintenanceOperatingHours'],
        'vehicleLastMaintenanceDate': value['vehicleLastMaintenanceDate'],
        'vehicleNextMaintenanceHours': value['vehicleNextMaintenanceHours'],
        'vehicleMaintenanceInterval': value['vehicleMaintenanceInterval'],
        'vehicleMaintenanceNotificationAt': value['vehicleMaintenanceNotificationAt'],
        'vehicleMaintenanceLockdown': value['vehicleMaintenanceLockdown'],
        'vehicleHoursUntilNextMaintenance': value['vehicleHoursUntilNextMaintenance'],
        'vehicleTypeLabel': value['vehicleTypeLabel'],
        'departmentLabel': value['departmentLabel'],
    };
}

